export default __webpack_public_path__ + "assets/bangladesh-flag.png";